<template lang="pug">
    .modal-documentos-regularidade
        .documents(v-if='resultado')
            button-component.document(
                v-for="(arquivo, index) in arquivos",
                :key="index",
                :label='arquivo.nome',
                :icon='arquivo.icon',
                color='red',
                background-color='white',
                border-color='red',
                @click.native='downloadDocumento(arquivo)'
            )

        modal-component(
            v-if='arquivoSelecionado',
            :title='"Justificativa - " + arquivoSelecionado.nome',
            width='35rem'
            @close='arquivoSelecionado = null'
        )
            p {{ arquivoSelecionado.justificativa }}
</template>

<script>
import {consultarRetornoDocumentosRegularidade, downloadDocumento, downloadDocumentoCentral} from '@/services/processo.service';

export default {
    name: 'ModalDocumentosRegularidade',
    props: {
        infoProcesso: Object,
    },
    data() {
        return {
            arquivoSelecionado: null,
            resultado: null,
            arquivos: []
        };
    },
    async mounted() {
        this.resultado = await consultarRetornoDocumentosRegularidade(this.infoProcesso.id);
        this.carregaArquivosParaDownload(this.resultado.documentosSolicitados || []);
    },
    methods: {
        async downloadDocumento(arquivo) {
            if (arquivo.justificativa) {
                this.arquivoSelecionado = arquivo;
            } else {
                const documento = await downloadDocumentoCentral(arquivo.idDocumento, arquivo.idArquivo);
                const file = window.URL.createObjectURL(new Blob([documento.data]));
                const docUrl = document.createElement('a');
                docUrl.href = file;
                docUrl.setAttribute('download', arquivo.nomeArquivo);
                document.body.appendChild(docUrl);
                docUrl.click();
            }
        },
        carregaArquivosParaDownload(documentosSolicitados) {
            documentosSolicitados.forEach(doc => {
                if (doc.dataEnvio) {
                    if (doc.justificativaItemSolicitacao) {
                        this.arquivos.push({
                            nome: doc.nome,
                            icon: 'mdi-file-document-outline',
                            justificativa: doc.justificativaItemSolicitacao.justificativa,
                        });
                    }

                    (doc.arquivos || []).forEach(arquivo => {
                        this.arquivos.push({
                            nome: doc.nome,
                            icon: 'mdi-file-pdf-box',
                            idDocumento: doc.id,
                            idArquivo: arquivo.id,
                            nomeArquivo: arquivo.nome,
                        });
                    });
                }
            });
        }
    },
};
</script>

<style></style>
